module.exports = __webpack_public_path__ + "img/SC-5799.77627712.png";